export default {
  methods: {
    defineAccess(tag, authLevel) {
      let obj = null;
      let list = null;
      if (tag === "C1") {
        list = this.infoAccessCompanyList;
      } else {
        list = this.infoAccessFacilityList;
      }
      obj = list[authLevel];
      return obj;
    }
  },
  data() {
    return {
      // eslint-disable-next-line
      infoAccessCompanyList: [
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Custodian",
          titles: "",
          tag: "G1", // access
          tagd: "C1", // tag destination access type
          // eslint-disable-next-line
          des: "Company access all privileges including granting access to new admin users.",
          // eslint-disable-next-line
          txt: "Controls company user access including reevoking access or modifying access. Company Data Custodian.",
          icon: "admin_panel_settings",
          icons: "admin_panel_settings",
          lev: 0
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Manager",
          titles: "",
          tag: "G1", // access
          tagd: "C1", // tag destination access type
          // eslint-disable-next-line
          des: "Admin user, all access.",
          // eslint-disable-next-line
          txt: "Responsible for vision and strategy of all company operations. Create or approve budget and operational plans. Company data info modifications.",
          icon: "looks_one",
          icons: "manage_accounts",
          lev: 1
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Leader",
          titles: "",
          tag: "G1", // access
          tagd: "C1", // tag destination access type
          // eslint-disable-next-line
          des: "Complete access to facility and its assets.",
          // eslint-disable-next-line
          txt: "Team supervisor and business process custodian Recommend budget and operational plans to the Manager. Modify budgets and plans as required.",
          icon: "looks_two",
          icons: "groups",
          lev: 2
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Coordinator",
          titles: "",
          tag: "G1", // access
          tagd: "C1", // tag destination access type
          // eslint-disable-next-line
          des: "Facility dashboard access and all asset edits.",
          // eslint-disable-next-line
          txt: "Responsible for execution plan or project or business unit. Create / edit / search budgets and operation plans. Approve financial orders for maintenance and projects..",
          icon: "looks_3",
          icons: "supervisor_account",
          lev: 3
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Planner",
          titles: "",
          tag: "G1", // access
          tagd: "C1", // tag destination access type
          // eslint-disable-next-line
          des: "Edit asset operational data, raise new or edit ops notifications.",
          // eslint-disable-next-line
          txt: "Project and execution controls expert to ensure optimised execution of approved plans. Create / edit / search operational plans for maintenance and projects.",
          icon: "looks_4",
          icons: "person",
          lev: 4
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Engineer",
          titles: "",
          tag: "G1", // access
          tagd: "C1", // tag destination access type
          // eslint-disable-next-line
          des: "Read only access to the facility and associated assets.",
          // eslint-disable-next-line
          txt: "Technical subject matter expert. Create / edit  company technical data. Edit budget and operational plans as require. Create financial orders for projects. Maintenance Strategy custodian.",
          icon: "looks_5",
          icons: "person_add",
          lev: 5
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Maintainer",
          titles: "",
          tag: "G1", // access
          tagd: "C1", // tag destination access type
          // eslint-disable-next-line
          des: "Time limited access for selected asset classes.",
          // eslint-disable-next-line
          txt: "Execution expert in specific technical discipline. Create engineering data, create / edit maintenance data, search materials. Create financial orders for maintenance work requests.",
          icon: "looks_6",
          icons: "psychology",
          lev: 6
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Operator",
          titles: "",
          tag: "G1", // access
          tagd: "C1", // tag destination access type
          // eslint-disable-next-line
          des: "Time limited access for selected asset classes.",
          // eslint-disable-next-line
          txt: "Operator technician dedicated to specific facility operations or routines. Search Hazards, search procedures and technical results to ensure safe production.",
          icon: "looks_6",
          icons: "contact_page",
          lev: 7
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Consultant",
          titles: "",
          tag: "G1", // access
          tagd: "C1", // tag destination access type
          // eslint-disable-next-line
          des: "Time limited access for selected asset classes.",
          // eslint-disable-next-line
          txt: "External expert to support business process, machine system and audits. Search company safety hazards.",
          icon: "looks_6",
          icons: "engineering",
          lev: 8
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Restricted",
          titles: "",
          tag: "G1", // access
          tagd: "C1", // tag destination access type
          // eslint-disable-next-line
          des: "Time limited access for selected asset classes.",
          // eslint-disable-next-line
          txt: "Limited access to company data. Promotion for higher access privileges can be requested at later date.",
          icon: "looks_6",
          icons: "settings",
          lev: 9
        }
      ],
      // eslint-disable-next-line
      infoAccessFacilityList: [
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Facility Founder",
          titles: "",
          tag: "G1", // access
          tagd: "F1", // tag destination access type
          // eslint-disable-next-line
          des: "Facility access all privileges including granting access to new admin users.",
          // eslint-disable-next-line
          txt: "Facility custodian controls user access. Facility Data Custodian.",
          icon: "admin_panel_settings",
          icons: "admin_panel_settings",
          lev: 0
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Manager",
          titles: "",
          tag: "G1", // access
          tagd: "F1", // tag destination access type
          // eslint-disable-next-line
          des: "All access to the company, selected facility and its assets.",
          // eslint-disable-next-line
          txt: "Responsible for safe operation of the facility. Approve budget and operational plan specific to the facility. Add facility data  modifications are permitted.",
          icon: "looks_one",
          icons: "manage_accounts",
          lev: 1
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Leader",
          titles: "",
          tag: "G1", // access
          tagd: "F1", // tag destination access type
          // eslint-disable-next-line
          des: "Complete access to facility and its assets.",
          // eslint-disable-next-line
          txt: "Superintendent or team leader for facility operations, maintenance or engineering. Mange execution plans. Generate maintenance calls. Close facility actions if required. Generate new maintenance plans from approved maintenance strategy.",
          icon: "looks_two",
          icons: "groups",
          lev: 2
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Engineer",
          titles: "",
          tag: "G1", // access
          tagd: "F1", // tag destination access type
          // eslint-disable-next-line
          des: "Facility dashboard access and all asset edits.",
          // eslint-disable-next-line
          txt: "Technical change management leader. Generate facility specific documents, create and edit engineering data. Answer emerging queries for maintenance and operations teams.",
          icon: "looks_3",
          icons: "engineering",
          lev: 3
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Maintainer",
          titles: "",
          tag: "G1", // access
          tagd: "F1", // tag destination access type
          // eslint-disable-next-line
          des: "Edit asset operational data, raise new or edit ops notifications.",
          // eslint-disable-next-line
          txt: "Technician or licenced trades person who is responsible for breakdown repairs and periodic inspections and tests. Create and edit operations notifications, create and edit work requests.",
          icon: "looks_4",
          icons: "contact_page",
          lev: 4
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Operator",
          titles: "",
          tag: "G1", // access
          tagd: "F1", // tag destination access type
          // eslint-disable-next-line
          des: "Read only access to the facility and associated assets.",
          // eslint-disable-next-line
          txt: "Area operator looking after day to day facility operations to ensure safe and reliable service or production. Create work requests for maintenance. Create and edit operations notifications, report incidents.",
          icon: "looks_5",
          icons: "person",
          lev: 5
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Integrated",
          titles: "",
          tag: "G1", // access
          tagd: "F1", // tag destination access type
          // eslint-disable-next-line
          des: "Time limited access for selected asset classes.",
          // eslint-disable-next-line
          txt: "Embedded contractor with access to internal facility business processes. Search for facility maintenance work and operational notifications. Investigate incidents via assigned actions in the user actions list.",
          icon: "looks_6",
          icons: "",
          lev: 6
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Contractor",
          titles: "",
          tag: "G1", // access
          tagd: "F1", // tag destination access type
          // eslint-disable-next-line
          des: "Time limited access for selected asset classes.",
          // eslint-disable-next-line
          txt: "External contractor responsible for single activity at the facility. Search for facility hazards relevant to the task and report safety incidents.",
          icon: "looks_6",
          icons: "",
          lev: 7
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Vendor",
          titles: "",
          tag: "G1", // access
          tagd: "F1", // tag destination access type
          // eslint-disable-next-line
          des: "Time limited access for selected asset classes.",
          // eslint-disable-next-line
          txt: "External subject matter expert for specific process or machine or service. Facility work planning and execution should be completed together with experienced facility staff or contractor. Create ops notification to report known activities and to identify potential issues.",
          icon: "looks_6",
          icons: "",
          lev: 8
        },
        {
          act: true, // is link active can you read it.
          show: true, // show in display lists
          title: "Restricted",
          titles: "",
          tag: "G1", // access
          tagd: "F1", // tag destination access type
          // eslint-disable-next-line
          des: "Time limited access for selected asset classes.",
          // eslint-disable-next-line
          txt: "Limited access to the facility. Permitted facility work execution only through user actions interface.",
          icon: "looks_6",
          icons: "",
          lev: 9
        }
      ]
    };
  }
};
